import { QueryKey, useQuery } from "react-query";
import { MAP_LAYERS_LIST_QUERY_KEY } from "./useMapLayer";
import { getMapFeatures } from "../queries/maps";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";

export function useMapLayerFeatures(id: number | string) {
  const queryKey = getMapLayerFeaturesQueryKey(id);

  const networkHeaders = useNetworkHeaders();
  const mapFeaturesQuery = useQuery(queryKey, () => getMapFeatures(networkHeaders)(id));

  return { mapFeaturesQuery, queryKey };
}

export function getMapLayerFeaturesQueryKey(id: number | string): QueryKey {
  return [MAP_LAYERS_LIST_QUERY_KEY, id.toString(), "features"] as const;
}
